module.exports = __webpack_public_path__ + "static/img/serviceplatform01_img.92a24a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/serviceplatform01_img.jpg
// module id = AJ0R
// module chunks = 1